import { useEffect, useState } from 'react';
import { RotatingLines } from 'react-loader-spinner';
import NavbarPlaceholder from '../components/NavbarPlaceholder';
import useDeviceSize from '../hooks/useDeviceSize';
import useEbcSolarStore from '../store/ebc-solar-store';
import { WidgetState } from '../types/states';

type TickItemProps = {
    text: string;
    delay: number;
};
const TickItem = ({ text, delay }: TickItemProps) => {
    const { width, height, isMobile } = useDeviceSize();

    const [active, setActive] = useState<boolean>(false);

    useEffect(() => {
        setTimeout(() => {
            setActive(true);
        }, delay);
    }, []);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '0.5rem',
            }}
        >
            {active ? (
                <img src='https://storage.googleapis.com/ebc-solar-quotation-widget/assets/GreenCircleTick.svg' />
            ) : (
                <RotatingLines strokeColor='#26A757' strokeWidth='5' animationDuration='0.75' width='40' visible={true} />
            )}
            <span
                style={{
                    fontSize: isMobile ? '20px' : '24px',
                    fontWeight: 600,
                }}
            >
                {text}
            </span>
        </div>
    );
};

export const CalculatingQuote = () => {
    const { width, height, isMobile } = useDeviceSize();

    const setState = useEbcSolarStore((state) => state.setState);

    useEffect(() => {
        setTimeout(() => {
            setState(WidgetState.QUOTATION_OVERVIEW);
        }, 5000);
    }, []);

    return (
        <div
            style={{
                minWidth: '100%',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <NavbarPlaceholder />
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginTop: '4rem',
                    gap: '2rem',
                    paddingBottom: '2rem',
                }}
            >
                <div
                    style={{
                        maxWidth: '90%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '2rem',
                    }}
                >
                    <div>
                        <img src='https://storage.googleapis.com/ebc-solar-quotation-widget/assets/solar-img-3.jpg' width={isMobile ? '256px' : '400px'} height='auto' />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '2rem',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '2rem',
                            }}
                        >
                            <TickItem text='Calculating your panels' delay={1000} />
                            <TickItem text='Calculating your savings potential' delay={2000} />
                            <TickItem text='Preparing a price estimate' delay={3000} />
                        </div>
                        {/* <div>
                            <RotatingLines strokeColor='#26A757' strokeWidth='5' animationDuration='0.75' width='64' visible={true} />
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CalculatingQuote;
